module.exports = __webpack_public_path__ + "img/smartphone_black1.819fcefa.png";